import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneSimpleEmailCode.styl';


Vue.component('BXmakerAuthuserphoneSimpleEmailCode',
    {
        props: {},
        data: function () {
            return {
                //��������� �������� ���� - ��������?
                // ��� ���������� �������� ����� ����� ����� - ��� �������������
                lastActionCheck: false,
            };
        },
        mounted() {
            this.$refs.refInputCode.focus();
        },
        computed: {},
        methods: {
            onInputCode(value) {
                this.$root.setEmailCode(value);

                if (this.$root.emailCodeLength === value.length && this.$root.isFullCaptcha) {
                    this.onClickCheck();
                }
            },
            onClickCheck() {
                this.lastActionCheck = true;
                this.$root.authByEmailCode();
            },
            onClickChangeEmail() {
                this.lastActionCheck = false;
                this.$root.resetMessage();
                this.$root.resetCaptcha();
                this.$root.hideConfirm();
                this.$root.resetCheck();
            },
            onClickStart() {
                this.lastActionCheck = false;
                this.$root.setEmailCode('');
                this.$root.startConfirmEmailCode();
            },

            onCompleteCaptcha() {
                if (!this.lastActionCheck) {
                    this.onClickStart();
                    return;
                }

                if (this.$root.emailCodeLength !== this.$root.emailCode.length) {
                    return false;
                }

                this.onClickCheck();
            },
            onCompleteTimeout() {
                this.$root.setEmailCodeTimeout(0);
            }
        },
        //language=Vue
        template: `
          <div class="bxmaker-authuserphone-simple-email-code">
            <slot name="header">
              <BXmakerAuthuserphoneHeader>
                {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_EMAIL_CODE_TITLE}}
              </BXmakerAuthuserphoneHeader>
            </slot>

            <slot name="message">
              <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error"/>
            </slot>

            <slot name="notice>">
              <div class="bxmaker-authuserphone-simple-email-code__notice">
                {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_EMAIL_CODE_NOTICE}}

                <span class="bxmaker-authuserphone-simple-email-code__email">{{$root.email}}</span>

                <BXmakerAuthuserphoneLink @onClick="onClickChangeEmail">
                  {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_EMAIL_CODE_CHANGE_PHONE}}
                </BXmakerAuthuserphoneLink>
              </div>
            </slot>

            <slot name="code">
              <BXmakerAuthuserphoneInputCode
                  :value="$root.emailCode"
                  @onInput="onInputCode"
                  @onEnter="onClickCheck"
                  ref="refInputCode"
                  :maxLength="$root.emailCodeLength"
                  :loader="$root.emailCodeCheckLoader"
                  :validationMessage="$root.emailCodeError"
              />
            </slot>

            <slot name="captcha">
              <BXmakerAuthuserphoneCaptcha
                  :code="$root.captchaCode"
                  :src="$root.captchaSrc"
                  :length="$root.captchaLength"
                  :loader="$root.captchaLoader"
                  @onInput="$root.setCaptchaCode"
                  @onComplete="onCompleteCaptcha"
                  @onRefresh="$root.refreshCaptcha"
              />
            </slot>

            <slot name="timeout">
              <BXmakerAuthuserphoneTimeout
                  :timeout="$root.emailCodeTimeout"
                  v-if="$root.emailCodeTimeout"
                  @onComplete="onCompleteTimeout">
                <template v-slot:before>
                  {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_EMAIL_CODE_TIMEOUT_TITLE}} <br>
                  {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_EMAIL_CODE_TIMEOUT_SUBTITLE}}
                </template>
              </BXmakerAuthuserphoneTimeout>
            </slot>

            <slot name="request">
              <div class="bxmaker-authuserphone-simple-email-code__send" v-if="!$root.emailCodeTimeout">
                <BXmakerAuthuserphoneLink @onClick="onClickStart" v-if="!$root.emailCodeStartLoader">
                  {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_EMAIL_CODE_GET_NEW}}
                </BXmakerAuthuserphoneLink>
                <BXmakerAuthuserphoneLoader class="bxmaker-authuserphone-simple-email-code__send-loader" v-else/>
              </div>
            </slot>

          </div>
        `,
    });